import { useV2GetUserQuery } from "@generated";
import { User } from "../types";
import { readUserPreferences } from "@components/PreferredDefaultsFields";

const useGetUserById = (id: string) => {
  const { data, isLoading, isFetching, refetch } = useV2GetUserQuery({
    id,
    include: ["teams", "rate-table", "currency"],
  });

  let user: User | null = null;

  if (data?.data) {
    user = {
      id: Number(data.data?.id),
      active: data.data?.attributes?.active || false,
      name: data.data?.attributes?.name || "",
      title: data.data?.attributes?.title || "",
      email: data.data?.attributes?.email || "",
      phone: data.data?.attributes?.phone || "",
      sales: data.data?.attributes?.sales || false,
      presales: data.data?.attributes?.presales || false,
      teams:
        data?.included
          ?.filter((item) => item.type === "teams")
          ?.map((t) => {
            return { label: String(t?.attributes?.name), value: String(t.id) };
          }) || [],
      roles:
        data.data?.attributes?.roles?.map((r) => {
          return { label: String(r.name), value: String(r.id) };
        }) || [],
      userType: data.data?.attributes?.["user-type"] || "",
      ssoProvider: data.data?.attributes?.["sso-provider"] || "",
      privileges: data?.data?.attributes?.privileges || {},
      startPage: data?.data?.attributes?.["start-page"] || "Home",
      ...readUserPreferences(data),
    };
  }

  return {
    data: user,
    isLoading,
    isFetching,
    refetch,
  };
};

export default useGetUserById;
